module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_maedori-8d96ea4e2801b1e8d77b17537007de0a.webp";